import { useState, useEffect } from "react";
import CTA from "../CTA/CTA";
import s from "./Header.module.scss";


const Header = () => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const handleLinkClick = () => {
        closeMenu();
    };

    const [activeLink, setActiveLink] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);
    // Gérer le scroll et la mise à jour du lien actif et le style du header
    useEffect(() => {
        const handleScroll = () => {
        const sections = document.querySelectorAll("section");
        const scrollPosition = window.scrollY + 100; 
        const scrollThreshold = window.innerHeight * 0.20;

        if (scrollPosition > scrollThreshold) {
            setIsScrolled(true); // Si défilement supérieur à 20vh, active l'animation
        } else {
            setIsScrolled(false);
        }

        sections.forEach((section) => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            const id = section.getAttribute("id");
            setActiveLink(`#${id}`);
            }
        });
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <header className={isScrolled ? s.scrolled : ""}>
            <nav className={s.headerDesktop}>
                <a href="#top"><img src="/assets/logoAVH.png" alt="Association Valentin Haüy, avec les aveugles et les malvoyants" /></a>
                <ul>
                    <li><a href="#campagnes" className={activeLink === "#campagnes" ? s.active : ""}>Nos campagnes</a></li>
                    <li><a href="#petitions" className={activeLink === "#petitions" ? s.active : ""}>Nos plaidoyers</a></li>
                </ul>
                <CTA />
            </nav>
            <nav className={s.headerMobile}>
                <a href="#top"><img src="/assets/logoAVH.png" alt="Association Valentin Haüy, avec les aveugles et les malvoyants" /></a>
                <div 
                    className={`${s.burger} ${isOpen ? s.open : ""}`} 
                    onClick={toggleMenu}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <ul className={`${isOpen ? s.menuOpen : ""}`}>
                    <li><a href="#campagnes" onClick={handleLinkClick}>Nos campagnes</a></li>
                    <li><a href="#petitions" onClick={handleLinkClick}>Nos plaidoyers</a></li>
                </ul>
            </nav>
        </header>
    )
};

export default Header;